import { Box, Grid, Typography, Button, useTheme, useMediaQuery } from "@mui/material";
import { useContext } from "react";
import { themeContext } from "../context";
import { motion } from "framer-motion";
import Card from "./shared/card";
import Resume from './Lakshay Rohilla Resume.pdf';
import javascriptLogo from "../img/javascriptLogo.png";
import kubernatesLogo from "../img/kubernatesLogo.png";
import reactLogo from "../img/reactLogo.png";
import swaggerLogo from "../img/swaggerLogo.png";

export default function Skills({ skillsPage }) {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;

    const themeHook = useTheme();
    const isSmallScreen = useMediaQuery(themeHook.breakpoints.down('md'));

    // Transition settings
    const transition = { duration: 1, type: "spring" };

    // Inline styles for the blur effects
    const blurStyles1 = {
        position: 'absolute',
        width: '300px',
        height: '150px',
        top: '10rem',
        left: '0rem',
        background: '#ABF1FF94',
        borderRadius: '30%',
        filter: 'blur(62px)',
        zIndex: -9
    };

    const blurStyles2 = {
        position: 'absolute',
        width: '300px',
        height: '150px',
        bottom: '-5rem',
        right: '-5rem',
        background: 'var(--purple)',
        borderRadius: '30%',
        filter: 'blur(62px)',
        zIndex: -9
    };

    return (
        <Box
            id="Skills"
            sx={{
                px: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                mb: skillsPage && 20, // Apply margin-y of 20 when skillsPage is true
                mt: skillsPage && 5
            }}
        >
            <Grid container spacing={4} sx={{ mb: 4 }} alignItems="center" direction={isSmallScreen ? 'column' : 'row'}>
                {/* Left Section */}
                <Grid item xs={12} md={5} sx={{ position: 'relative' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: -2 }}>
                        <Typography variant="h3" sx={{ fontWeight: 'bold', color: darkMode ? "white" : "black" }}>
                            Technical <span style={{ color: 'var(--orange)', fontWeight: 'bold' }}>Skills</span>
                        </Typography>
                        <Typography variant="body1" sx={{ color: 'text.secondary', mt: 2, mb: 3 }}>
                            These are the tech stacks I have worked with until now !!
                        </Typography>
                        <a href={Resume} download>
                            <Button className="button" sx={{
                                color: 'white',
                                borderRadius: '20px',
                                p: 1,
                                pr: 3,
                                pl: 3,
                                fontWeight: 'bold'
                            }}>
                                Download Resume
                            </Button>
                        </a>
                        {/* Blur effect in left section */}
                        <div style={blurStyles1}></div>
                    </Box>
                </Grid>

                {/* Right Section */}
                <Grid item xs={12} md={7} sx={{ position: 'relative' }}>
                    <Box sx={{ display: 'grid', gridTemplateColumns: isSmallScreen ? '1fr' : 'repeat(2, 1fr)', gap: 2 }}>
                        {/* Skills Cards */}
                        <motion.div
                            initial={{ x: isSmallScreen ? "0rem" : "25rem" }}
                            whileInView={{ x: "0rem", y: isSmallScreen ? "0rem" : "11rem" }}
                            transition={transition}
                            viewport={{ once: false, amount: 0.1 }}
                            style={{ width: '100%', maxWidth: '300px', margin: '0 auto' }}
                        >
                            <Card
                                image={javascriptLogo}
                                heading={'Languages'}
                                description={'JavaScript, Python, SQL, HTML, CSS, Linux/Unix Shell Scripting, Web Services (RESTful)'}
                            />
                        </motion.div>
                        <motion.div
                            initial={{ x: isSmallScreen ? "0rem" : "-11rem", y: isSmallScreen ? "0rem" : "15rem" }}
                            whileInView={{ x: "0rem", y: isSmallScreen ? "0rem" : "0rem" }}
                            transition={transition}
                            viewport={{ once: false, amount: 0.1 }}
                            style={{ width: '100%', maxWidth: '300px', margin: '0 auto' }}
                        >
                            <Card
                                image={reactLogo}
                                heading={'Frameworks'}
                                description={'FastAPI, Angular, React, Bootstrap, Plasma'}
                            />
                        </motion.div>
                        <motion.div
                            initial={{ x: isSmallScreen ? "0rem" : "28rem" }}
                            whileInView={{ x: "0rem", y: isSmallScreen ? "0rem" : '11.5rem' }}
                            transition={transition}
                            viewport={{ once: false, amount: 0.1 }}
                            style={{ width: '100%', maxWidth: '300px', margin: '0 auto' }}
                        >
                            <Card
                                image={kubernatesLogo}
                                heading={'DevOps Tools'}
                                description={'Kubernetes, Git, Docker, Gitea, Bitbucket, Gitlab'}
                            />
                        </motion.div>
                        <motion.div
                            initial={{ x: isSmallScreen ? "0rem" : "-8rem" }}
                            whileInView={{ x: "0rem", y: isSmallScreen ? "0rem" : "-2rem" }}
                            transition={transition}
                            viewport={{ once: false, amount: 0.1 }}
                            style={{ width: '100%', maxWidth: '300px', margin: '0 auto' }}
                        >
                            <Card
                                image={swaggerLogo}
                                heading={'Other Tools'}
                                description={'Jira, Jenkins, Swagger, Postman, Insomnia, Draw.io, Linters, Make, Poetry, Pydantic'}
                            />
                        </motion.div>
                    </Box>
                    {/* Blur effect in right section */}
                    <div style={blurStyles2}></div>
                </Grid>
            </Grid>
        </Box>
    );
}